import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PricePipe } from './pipes/price.pipe';
import { L10nPipe } from './pipes/l10n.pipe';
import { BasicDialogComponent } from './dialog/basic-dialog/basic-dialog.component';
import { RegistrationPricingInfoComponent } from './components/registration-pricing-info/registration-pricing-info.component';
import { PersonInfoComponent } from './components/person-info/person-info.component';
import { MessagesComponent } from './components/messages/messages.component';
import { L10nService } from './services/l10n.service';
import { MessageService } from './services/message.service';
import { RegistrationService } from './services/registration.service';
import { TrustPayService } from './services/trust-pay.service';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { DayOfWeekPipe } from './pipes/day-of-week.pipe';
import { RouterModule } from '@angular/router';
import { TimePipe } from './pipes/time.pipe';
import { TeacherProfileComponent } from './dialog/teacher-profile/teacher-profile.component';
import { LocalizedDatePipe } from './pipes/localized-date.pipe';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorResponseInterceptorService } from './services/error-response-interceptor.service';
import { BroadcastService } from './services/broadcast.service';

@NgModule({
  declarations: [
    PricePipe,
    L10nPipe,
    DayOfWeekPipe,
    RegistrationPricingInfoComponent,
    PersonInfoComponent,
    BasicDialogComponent,
    MessagesComponent,
    TimePipe,
    TeacherProfileComponent,
    LocalizedDatePipe
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbAlertModule
  ],
  exports: [
    PricePipe,
    L10nPipe,
    DayOfWeekPipe,
    TimePipe,
    LocalizedDatePipe,
    RegistrationPricingInfoComponent,
    PersonInfoComponent,
    BasicDialogComponent,
    MessagesComponent,
    TeacherProfileComponent
  ],
  providers: [
    L10nService,
    MessageService,
    RegistrationService,
    TrustPayService,
    BroadcastService,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorResponseInterceptorService, multi: true },
  ],
  entryComponents: [
    TeacherProfileComponent
  ]
})
export class SharedModule { }

export * from './services/l10n.service';
export * from './services/message.service';
export * from './services/registration.service';
export * from './services/trust-pay.service';
export * from './services/broadcast.service';
export * from './models/common.model';
export * from './models/rest.model';
export * from './dialog/teacher-profile/teacher-profile.component';
